import React from 'react';


const routes = [
    {
        path: '/',
        exact: true,
        component: React.lazy(() => import('@/pages/play')),
        isBeforeRoute: true,
    },
    {
        path: '/play',
        exact: true,
        component: React.lazy(() => import('@/pages/play')),
        isBeforeRoute: true,
    },
    {
        path: '/assistant',
        exact: true,
        component: React.lazy(() => import('@/pages/assistant')),
        isBeforeRoute: true,
    },
    {
        path: '/selftest',
        exact: true,
        component: React.lazy(() => import('@/pages/selfTest')),
        isBeforeRoute: false,
    },
    {
        path: '/auth',
        exact: true,
        component: React.lazy(() => import('@/pages/auth')),
        isBeforeRoute: false,
    },
    {
        path: '/:pn/play',
        exact: true,
        component: React.lazy(() => import('@/pages/play')),
        isBeforeRoute: true,
    },
    {
        path: '/:pn/assistant',
        exact: true,
        component: React.lazy(() => import('@/pages/assistant')),
        isBeforeRoute: true,
    },
    {
        path: '/:pn/auth',
        exact: true,
        component: React.lazy(() => import('@/pages/auth')),
        isBeforeRoute: false,
    },
    {
        path: '/visit',
        exact: true,
        component: React.lazy(() => import('@/pages/visit')),
        isBeforeRoute: false,
    },
];

export default routes;
